import { createMuiTheme } from "@material-ui/core/styles";

export const AppTheme = createMuiTheme({
  palette: {
    primary: {
      main: "#951981",
    },
    secondary: {
      main: "#6ab023",
    },
  },
  overrides: {
    MuiSelect: {
      select: {
        textAlign: "left",
      },
    },
  },
});
